// src/app/utility/i18n/translate.pipe.ts
// ════════════════════════════════════════════════════════════════════════════
// DE-6 — the translation pipe.  Usage:  {{ 'dataentry.forms.pick_project' | t }}
//                                       {{ 'records.count' | t: { n: rows.length } }}
//
// `pure: false` is DELIBERATE and is the only way this works.
//   A pure pipe caches on its inputs. The key does not change when the language does — so a pure
//   pipe would render Hindi once and then never update when the user switches to Telugu, because
//   Angular would see the same input and skip it. Every label on the page would freeze in the old
//   language until a full navigation.
//
// The cost of impure is that it re-runs on every change-detection pass. That is affordable here
// because `t()` is a Map lookup — O(1), no allocation, no string building unless there are params.
// The alternative (an async pipe over an observable per label) allocates a subscription per label
// and is strictly worse.
// ════════════════════════════════════════════════════════════════════════════
import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '../../services/i18n.service';

@Pipe({ name: 't', pure: false })
export class TranslatePipe implements PipeTransform {

  constructor(private i18n: I18nService) {}

  transform(key: string, params?: Record<string, any>): string {
    if (!key) return '';
    return this.i18n.t(key, params);
  }
}
